import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useIsMobile } from "../actions/ui";
import { useParams, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Box, Button, Stack, TextField } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { LinearIndeterminateProgressLoader } from "./LinearIndeterminateProgressLoader";
import { customerBibNumberRecognition } from "../v2_actions/customer_bib_number_recognition";

const useStyles = makeStyles((theme) => ({
  submitBibNumber: {
    height: 40,
    width: 20,
    fontSize: 10,
    cursor: "pointer",
  },
  cancelButton: {
    height: 28,
    width: 134,
    background: "#929292",
    "& p": {
      fontSize: 12,
      fontWeight: 600,
    },
  },
  submitButton: {
    height: 28,
    width: 134,
    "& p": {
      fontSize: 12,
      fontWeight: 600,
    },
  },
  bibNumberInput: {
    "& input": {
      textAlign: "center",
    },
    "& input::placeholder": {
      textAlign: "center",
    },
  },
}));

export default function BibNumber({
  gallery,
  bibNumber,
  onChangeBibNumber,
  onSubmitBibNumber,
  onCancelBibNumber,
  setExpandActiveMobileTabFilter,
  mayPerformBibNumberIndexingOfGalleryPhotographs,
}) {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { galleryId } = useParams();
  const [
    galleryBibNumberIndexingInProgress,
    setGalleryBibNumberIndexingInProgress,
  ] = useState(false);
  const hasValidBibNumbers = get(
    gallery,
    "has_valid_bib_numbers",
  );
  const bibIndexStatus = get(
    gallery,
    "indexed_for_bib_number_recognition",
  );
  const isGalleryIndexedForBibRecognition = bibIndexStatus === "indexed" || bibIndexStatus === "partial";

  useEffect(() => {
    if (
      bibIndexStatus === "not_indexed" &&
      mayPerformBibNumberIndexingOfGalleryPhotographs
    ) {
      onBibNumberIndexGalleryPhotographs();
    }
  }, [gallery, mayPerformBibNumberIndexingOfGalleryPhotographs]);

  const onBibNumberIndexGalleryPhotographs = () => {
    if (!isGalleryIndexedForBibRecognition) {
      setGalleryBibNumberIndexingInProgress(true);
      const on_done = (json) => {
        if (json.status !== "success") {
          console.error(get(json, "message"));
        }
        setGalleryBibNumberIndexingInProgress(false);
      };
      dispatch(customerBibNumberRecognition.indexGallery(galleryId)).then(
        on_done,
      );
    }
  };

  const clearBibNumber = () => {
    if (setExpandActiveMobileTabFilter) {
      setExpandActiveMobileTabFilter(false);
    }
  };

  const renderError = () => {
    return (
      <Box sx={{ width: 300 }}>
        <div>There are no bib numbers to search for.</div>
        {isMobile && (
          <Stack
            mt={3}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Button
              variant="contained"
              sx={{ background: "#929292" }}
              className={classes.cancelButton}
              onClick={clearBibNumber}
            >
              <p>Cancel</p>
            </Button>
          </Stack>
        )}
      </Box>
    );
  }

  const renderSuccess = () => {
    return (
      <Box sx={{ width: 300 }}>
        <Stack
          spacing={1}
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <TextField
            size="small"
            variant="outlined"
            value={bibNumber}
            placeholder="Enter bib number"
            onChange={onChangeBibNumber}
            className={classes.bibNumberInput}
            inputProps={{ style: { textAlign: "center" } }}
            autoComplete="bibnumber"
          />
          {!isMobile && (
            <ArrowForwardIosIcon
              onClick={onSubmitBibNumber}
              className={classes.submitBibNumber}
            />
          )}
        </Stack>
        {isMobile && (
          <Stack
            mt={3}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Button
              variant="contained"
              sx={{ background: "#929292" }}
              className={classes.cancelButton}
              onClick={clearBibNumber}
            >
              <p>Cancel</p>
            </Button>
            <Button
              variant="contained"
              onClick={onSubmitBibNumber}
              className={classes.submitButton}
            >
              <p>Search</p>
            </Button>
          </Stack>
        )}
        {galleryBibNumberIndexingInProgress && (
          <div>
            <LinearIndeterminateProgressLoader />
            <small className={classes.indexingInProgressMessage}>
              Indexing gallery...
            </small>
          </div>
        )}
      </Box>
    );
  }
  
  if (hasValidBibNumbers || isGalleryIndexedForBibRecognition) {
    return renderSuccess()
  } else {
    return renderError()
  }
}
